import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import React, { useEffect, useState, VFC } from 'react'
import styles from '../../styles/front/top/SiteTopKeyVisual.module.sass'
import SliderDot from './SliderDot'

type Constants = {
  H1_TAG_POSITION_KEY_VISUAL: number
  H1_TAG_POSITION_UPPER_RIGHT: number
}

type Props = {
  CatchCopy: string
  SpCatchCopy: string
  keyVisualImages: string[]
  keyVisualSpImages: string[]
  keyVisualBadgeImages: string[]
  keyVisualImageAlts: string[]
  keyVisualSpImageAlts: string[]
  theme_color: string
  main_visual_design_pattern: number
  key_visual_catch_copy_color_pc: number
  key_visual_catch_copy_color_sp: number
  key_visual_catch_copy_text_align_pc: number
  key_visual_catch_copy_text_align_sp: number
  default_alt: string
  h1_tag_position: number
  top_key_visual_scroll_down_button_disp: number
  constants: Constants
  top_page: boolean
}

const SiteTopKeyVisual: VFC<Props> = (props) => {
  const {
    CatchCopy,
    SpCatchCopy,
    keyVisualImages,
    keyVisualSpImages,
    keyVisualBadgeImages,
    keyVisualImageAlts,
    keyVisualSpImageAlts,
    main_visual_design_pattern,
    key_visual_catch_copy_color_pc,
    key_visual_catch_copy_color_sp,
    key_visual_catch_copy_text_align_pc,
    key_visual_catch_copy_text_align_sp,
    default_alt,
    h1_tag_position,
    top_key_visual_scroll_down_button_disp,
    constants,
    top_page,
  } = props

  const theme_color = '-' + props.theme_color

  const isPC = () => {
    return (
      document.querySelector('.menu-list') &&
      document.defaultView.getComputedStyle(document.querySelector('.menu-list'), null).display !== 'none'
    )
  }

  const catchCopyMessage = isPC() ? props.CatchCopy : props.SpCatchCopy
  const [currentKeyVisualSlide, setCurrentKeyVisualSlide] = useState(0)
  const [keyVisualSlideLoaded, setKeyVisualLoaded] = useState(false)
  const [opacities, setOpacities] = useState([])
  const [sizeList, setSizeList] = useState([])
  const [KeyVisualSliderRef, instanceKeyVisualSliderRef] = useKeenSlider(
    {
      slides: isPC() || keyVisualSpImages.length == 0 ? keyVisualImages.length : keyVisualSpImages.length,
      defaultAnimation: {
        duration: 3500,
      },
      loop: true,
      rtl: true,
      slideChanged(slider) {
        setCurrentKeyVisualSlide(slider.track.details.rel)
      },
      created() {
        setKeyVisualLoaded(true)
      },
      detailsChanged(s) {
        const new_opacities = s.track.details.slides.map((slide) => slide.portion)
        setOpacities(new_opacities)
      },
    },
    [
      (slider) => {
        let timeout: ReturnType<typeof setTimeout>
        function nextTimeout() {
          clearTimeout(timeout)
          timeout = setTimeout(() => {
            slider.next()
          }, 3000)
        }
        slider.on('created', () => {
          nextTimeout()
        })
        slider.on('animationEnded', nextTimeout)
        slider.on('updated', nextTimeout)
      },
    ]
  )

  const handleOnError = (e: any, image: string) => {
    if (e.target.src !== image) {
      e.target.onerror = null
      e.target.src = image
    }
  }

  const getImageHeight = (height: number, index: number) => {
    let list = sizeList
    list[index] = height
    setSizeList(list)
  }

  const outputCatchCopyStylePC = () => {
    if (top_page) {
      return
    }
    if (isPC()) return key_visual_catch_copy_color_pc == 0 ? styles.textBlack : styles.textWhite
    return key_visual_catch_copy_color_sp == 0 ? styles.textBlack : styles.textWhite
  }

  const outputTopImagesMessage = () => {
    if (top_page) {
      return
    }
    let underTextAlignStyle =
      keyVisualSlideLoaded && instanceKeyVisualSliderRef.current
        ? styles.textAlignUnderWithSlider
        : styles.textAlignUnderWithoutSlider
    let textAlignStyle = ''
    let textFontStyle = ''
    let scrollDown = ''
    if (isPC()) {
      textAlignStyle = key_visual_catch_copy_text_align_pc == 0 ? styles.textAlignCenter : underTextAlignStyle
      textFontStyle =
        key_visual_catch_copy_text_align_pc == 0 ? styles.textAlignCenterFontSize : styles.textAlignUnderFontSize
      scrollDown = key_visual_catch_copy_text_align_pc == 0 ? 'center' : 'end'
    } else {
      textAlignStyle = key_visual_catch_copy_text_align_sp == 0 ? styles.textAlignCenter : underTextAlignStyle
      textFontStyle =
        key_visual_catch_copy_text_align_sp == 0 ? styles.textAlignCenterFontSize : styles.textAlignUnderFontSize
      scrollDown = key_visual_catch_copy_text_align_sp == 0 ? 'center' : 'end'
    }

    return (
      textAlignStyle +
      ' ' +
      textFontStyle +
      ' ' +
      styles.topImagesMessage +
      ' ' +
      'text-align-wrapper' +
      ' ' +
      scrollDown
    )
  }

  const scrollDownClass = () => {
    let position = ''
    if (isPC()) {
      position = key_visual_catch_copy_text_align_pc == 0 ? 'under' : 'center'
    } else {
      position = key_visual_catch_copy_text_align_sp == 0 ? 'under' : 'center'
    }
    return 'scroll_down-container ' + position
  }

  useEffect(() => {
    const currentWidth = document.documentElement.clientWidth
    const term = 100
    let timer = 0
    window.addEventListener('resize', () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (currentWidth != document.documentElement.clientWidth) {
          // 画像のサイズを再取得したいのでリサイズしたらリロードする
          location.reload()
        }
      }, term)
    })
  }, [])

  return (
    <div className={styles.topImages}>
      <div className={styles.topImageContainer}>
        {isPC() && (
          <>
            {keyVisualImages.length > 0 && (
              <div
                id="keyVisual"
                ref={keyVisualImages.length > 1 ? KeyVisualSliderRef : undefined}
                className={styles.fader + ' ' + styles[theme_color] + ' ' + styles.fill}
              >
                {keyVisualImages.length > 0 &&
                  keyVisualImages
                    .filter((image) => image != null)
                    .map((keyImage, index) => (
                      <React.Fragment key={index}>
                        <SiteTopImage
                          index={index}
                          opacity={opacities[index]}
                          imageAlt={keyVisualImageAlts[index]}
                          image={keyImage}
                          badgeImages={keyVisualBadgeImages}
                          error={handleOnError}
                          loadImage={getImageHeight}
                          replaceTarget="/store/key_visual/"
                          replaceText="/store/key_visual/resize_1920x/"
                          default_alt={default_alt}
                        />
                      </React.Fragment>
                    ))}
              </div>
            )}
            {keyVisualImages.length == 0 && <div className="top-no_images"></div>}
          </>
        )}
        {!isPC() && (
          <>
            {keyVisualSpImages.length > 0 && (
              <div
                id="keyVisual"
                ref={keyVisualSpImages.length > 1 ? KeyVisualSliderRef : undefined}
                className={styles.fader + ' ' + styles[theme_color] + ' ' + styles.fill}
              >
                {keyVisualSpImages.length > 0 &&
                  keyVisualSpImages
                    .filter((image) => image != null)
                    .map((spImage, index) => (
                      <React.Fragment key={index}>
                        <SiteTopImage
                          index={index}
                          opacity={opacities[index]}
                          imageAlt={keyVisualSpImageAlts[index]}
                          image={spImage}
                          badgeImages={keyVisualBadgeImages}
                          error={handleOnError}
                          loadImage={getImageHeight}
                          replaceTarget="/store/key_visual_sp/"
                          replaceText="/store/key_visual_sp/resize_774x/"
                          default_alt={default_alt}
                        />
                      </React.Fragment>
                    ))}
              </div>
            )}
            {keyVisualSpImages.length == 0 && keyVisualImages.length > 0 && (
              <div
                id="keyVisual"
                ref={keyVisualImages.length > 1 ? KeyVisualSliderRef : undefined}
                className={styles.fader + ' ' + styles[theme_color] + ' ' + styles.fill}
                style={sizeList.length === 0 ? pcLoadingStyle : { height: `${sizeList[currentKeyVisualSlide]}px` }}
              >
                {keyVisualImages.length > 0 &&
                  keyVisualImages
                    .filter((image) => image != null)
                    .map((spImage, index) => (
                      <React.Fragment key={index}>
                        <SiteTopImage
                          index={index}
                          opacity={opacities[index]}
                          imageAlt={keyVisualImageAlts[index]}
                          image={spImage}
                          badgeImages={keyVisualBadgeImages}
                          error={handleOnError}
                          loadImage={getImageHeight}
                          replaceTarget="/store/key_visual/"
                          replaceText="/store/key_visual/resize_774x/"
                          default_alt={default_alt}
                        />
                      </React.Fragment>
                    ))}
              </div>
            )}
            {keyVisualImages.length == 0 && keyVisualSpImages.length == 0 && (
              <div className="top-images__spImage"></div>
            )}
          </>
        )}
      </div>
      {keyVisualSlideLoaded && instanceKeyVisualSliderRef.current && (
        <div className={styles.full_screen}>
          {[...Array(instanceKeyVisualSliderRef.current.track.details.slides.length).keys()].map((index) => (
            <React.Fragment key={index}>
              <SliderDot
                index={index}
                instanceRef={instanceKeyVisualSliderRef}
                currentSlide={currentKeyVisualSlide}
                styles={styles}
                theme_color={theme_color}
                main_visual_design_pattern={main_visual_design_pattern}
              />
            </React.Fragment>
          ))}
        </div>
      )}

      <div className={outputTopImagesMessage()}>
        {h1_tag_position == constants.H1_TAG_POSITION_KEY_VISUAL && (
          <h1 className={outputCatchCopyStylePC()}>
            <div dangerouslySetInnerHTML={{ __html: catchCopyMessage }} />
          </h1>
        )}
        {h1_tag_position == constants.H1_TAG_POSITION_UPPER_RIGHT && (
          <div className={outputCatchCopyStylePC()}>
            <div dangerouslySetInnerHTML={{ __html: catchCopyMessage }} />
          </div>
        )}
      </div>

      {top_key_visual_scroll_down_button_disp == true && (
        <div className={scrollDownClass()}>
          <a className="scroll_down" id="scroll_down">
            <div>Scroll</div>
          </a>
        </div>
      )}
    </div>
  )
}

type SiteTopImageProps = {
  index: number
  opacity: number
  imageAlt: string
  image: string
  badgeImages: string[]
  error: (error, image) => void
  replaceTarget: string
  replaceText: string
  loadImage: (height: number, index: number) => void
  default_alt: string
}

const SiteTopImage = (props: SiteTopImageProps) => {
  const { index, opacity, imageAlt, image, badgeImages, error, replaceTarget, replaceText, loadImage, default_alt } =
    props

  return (
    <div className={styles.fader__slide} key={index} style={{ opacity: opacity }}>
      <img
        alt={imageAlt}
        src={image.replace(replaceTarget, replaceText).replace(/.(png|jpg|jpeg)$/, '.webp')}
        className={styles.keyVisualImage}
        onError={(e) => error(e, image)}
        onLoad={(image) => loadImage(image.target.height, index)}
      />
      <div className={styles.badgeImageContainer}>
        {badgeImages.length > 0 &&
          badgeImages
            .filter((image) => image != null)
            .map((badgeImageUrl, index) => (
              <img
                alt={default_alt}
                key={index}
                src={badgeImageUrl
                  .replace('/store/key_visual_badge/', '/store/key_visual_badge/resize_280x/')
                  .replace(/.(png|jpg|jpeg)$/, '.webp')}
                loading="lazy"
                onError={(e) => error(e, badgeImageUrl)}
              />
            ))}
      </div>
    </div>
  )
}

export default SiteTopKeyVisual
